import Cookies from 'js-cookie'

const state = {
  sidebar:Cookies.get('sidebarStatus')!=null?Cookies.get('sidebarStatus'):true,
  waiting:false,
  alert:false,
  site:null
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar = !state.sidebar
    if (state.sidebar){
      Cookies.set('sidebarStatus', true)
    }else{
      Cookies.set('sidebarStatus', false)
    }
  },
  SHOW_WAITING:state => {
    state.waiting = true
  },
  CLOSE_WAITING:state => {
    state.waiting = false
  },
  CHANGE_SITE: (state,site) => {

    state.site = site
    localStorage.setItem("site",JSON.stringify(site))
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  showWaiting({ commit }){
    commit('SHOW_WAITING')
  },
  closeWaiting({commit}){
    commit('CLOSE_WAITING')
  },
  changeSite({commit},data){
    commit('CHANGE_SITE',data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js